import { Company } from '@paymash/sdk/models/backend/company';

export const COMPANY: Company = {
  name: 'Test',
  uuid: '233-33-222-dd',
  address: {
    address: 'test-address',
    business: 'test-business',
    city: 'test-city',
    country: 'test-country',
    firstName: 'test firstname',
    lastName: 'test lastname',
    phoneNr: 'test phone',
    phoneNrMobile: 'test phone mobile',
    postalCode: 'test-postal-code',
    salutation: 'test salutation',
    uuid: 'test-uuid',
  },
  email: 'test@gmail.com',
  homepage: 'test.com',
  locale: {
    currency: 'CHF',
    currencyRounding: 'ZERO_DOT_ZERO_FIVE',
    dateFormat: 'DD_MM_YYYY_DOT',
    dateFormatString: 'dd.MM.yyyy',
    numberFormat: 'APOSTROPHE_DOT',
    numberFormatString: "'_.",
  },
  themeName: 'theme-1',
  description: 'Some text about company',
  image: {
    uuid: 'ddd-ddd-3333',
    thumbs: [
      {
        url: 'https://paymash-test.s3.amazonaws.com/companies/24972/ccf5e8bb-d3f1-4635-bb8f-93835a819a5d/1200_1200.JPEG',
        size: 'original',
      },
    ],
  },
  companyHomepage: 'http://test-company.com',
  bookingEnabled: false,
  selfOrderingEnabled: false,
  isWebShopEnabled: false,
  webShopUrl: null,
  bookingSettings: {
    calendarAccuracy: null,
    cancellationPolicy: null,
    notEarlyThan: null,
    notLaterThan: null,
    reminderFrequencyOfNotification: 1,
    servicesPerBooking: 3,
    showOnlyBookableHours: true,
    stores: [],
    timeIntervals: 0,
  },
};
